import ValueCompass from "components/value/ValueCompass";
import ContentTemplateV2 from "../content/ContentTemplateV2";

export default function MyValueCompassContent() {
  return (
    <ContentTemplateV2>
      <ValueCompass />
    </ContentTemplateV2>
  );
}
